import { useRuntimeConfig } from '#imports'

import type { Market } from '@backmarket/http-api'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'
import type { RouteRecordRaw } from 'vue-router'

import { HOME } from './route-names'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const defaultLocale = toBcp47Locale(market.defaultLocale)

  const { FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_HOME } =
    useRuntimeConfig().public

  const isFrontAppsRouteOpenedInCountry = (
    FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_HOME as string
  ).includes(market.countryCode)

  return [
    {
      path: '/',
      redirect: `/${defaultLocale}`,
    },
    {
      component: () => import('./Home.vue'),
      name: HOME,
      path: `/:locale(${defaultLocale})`,
      meta: {
        disableClientSideNavigation: () => !isFrontAppsRouteOpenedInCountry,
      },
    },
  ]
}
